import { Button, Icon } from "@mui/material";
import { useEffect, useState } from "react";

export type ButtonIconType = "add" | "pencil" | "arrow_back" | "block" | "save" | "download" | "upload" | "check" | "clear" | "remove" | "back" | "login" | "lock_reset" | "print";
export type ButtonVariant = 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';

export const StandardButton = (params: {
    icon?: ButtonIconType,
    children: React.ReactNode,
    onClick?: (event: any) => void;
    variant?: ButtonVariant,
    saving?: boolean,
    loading?: boolean,
    disabled?: boolean,
    type?: "button" | "submit",
    // key?: string
}) => {


    const getIcon = () => {
        switch (params.icon) {
            case ("back"):
                return "arrow_back";
            default:
                return params.icon;
        }
    }

    return (
        <Button fullWidth disabled={params.disabled || params.loading || params.saving} color={params.variant || "primary"} type={params.type || "button"} sx={{ fontSize: '0.9rem !important' }} variant="contained" disableElevation startIcon={
            <Icon sx={{ fontSize: '1.4rem !important' }}>{getIcon()}</Icon>} onClick={params.onClick}>

            {(params.saving !== true && params.loading !== true && params.children) && <>{params.children}</>}

            {(params.saving === true) &&
                <>Saving<LoadingDots /></>
            }

            {(params.loading === true) &&
                <>Loading<LoadingDots /></>
            }
        </Button>

    );
}

const LoadingDots = () => {
    const [loadingStatus, setLoadingStatus] = useState("..");

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLoadingStatus(ls => ls.length >= 5 ? ".." : ls + ".");
        }, 400);

        return () => clearInterval(intervalId);
    }, []);

    return <>{`${loadingStatus}`}</>;
};